<template>
  <div class="floating">
    <div class="leftmenuCon">
      <div
        class="itemBox"
        v-for="(item, index) in textData"
        :key="index"
        @click="scrollToTop(index)"
        :class="{ active: index == scrollIndex }"
      >
        {{ item.home_name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  emits: ["scrollToTop"],
  props: {
    textData: {
      type: Array,
      // required: true,
    },

    // count: {
    //   type: Number,

    //   default: 0,
    // },
  },

  data() {
    return {
      scrollIndex: 0,
    };
  },
  components: {},
  computed: {},
  created() {},
  mounted() {
    // this.throttle(() => {
    window.addEventListener("scroll", this.getscrollIndex);
    // }, 50);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.getscrollIndex);
  },
  methods: {
    scrollToTop(index) {
      this.$emit("scrollToTop", index);
    },

    getscrollIndex() {
      let dd = document.documentElement;
      let topNum = dd.scrollTop;

      for (let i = this.textData.length - 1; i >= 0; i--) {
        if (topNum >= this.textData[i].offsetTop - 50) {
          this.scrollIndex = i;
          break;
        }
      }
    },
    throttle(fn, delay) {
      let timer = null;
      return function() {
        let context = this;
        let args = arguments;
        if (!timer) {
          timer = setTimeout(function() {
            fn.apply(context, args);
            timer = null;
          }, delay);
        }
      };
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.floating {
  position: sticky;
  top: 150px;
  left: 165px;
  height: 0;
  width: 300px;
  z-index: 1;

  .leftmenuCon {
    position: absolute;
    margin-top: 50px;
    width: max-content;
    padding: 10px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f0f3f6;
    margin-right: 100px;
    .itemBox {
      min-width: 150px;
      border-radius: 8px;
      // 与设计稿未选中态一致：黑色字 #000000，16S，无背景
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      color: #000000;
      padding: 10px 20px;
      cursor: pointer;
      // 与设计稿一致：鼠标移入/选中 — 品牌色浅底 #EAF8E8 + 主色字 #009246
      &:hover,
      &.active {
        background: #eaf8e8;
        color: #009246;
      }
    }
  }
}
</style>
